import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

const SelectFilter = ({ column: { setFilter, preFilteredRows, id, filterValue, filterType, options, filterIconId }, className }) => {
  const [inputValue, setInputValue] = React.useState('');
  const [showFilter, setShowFilter] = React.useState(false);
  const formtypes = useSelector(state => state.auth.settings.formtypes);

  const node = React.useRef();
  const handleClickOutside = (e) => {
    if (node === null || node.current === null) {
      return;
    }
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    setShowFilter(false);
  };

  const baseOptions = React.useMemo(() => {
    let opts = new Set();

    switch (id) {
      case 'workflowStatus':
      case 'workflowStageDescription':
        opts = new Set();
        opts.add({ title: 'Pending Initial Review', value: 'pendingreview' });
        opts.add({ title: 'Under Initial Review', value: 'underinitialreview' });
        opts.add({ title: 'Pending Secondary Review', value: 'pendingsecondaryreview' });
        opts.add({ title: 'Under Secondary Review', value: 'undersecondaryreview' });
        opts.add({ title: 'Pending Expert Review', value: 'pendingexpertreview' });
        opts.add({ title: 'Under Expert Review', value: 'underexpertreview' });
        opts.add({ title: 'Complete', value: 'complete' });
        break;
      case 'formTypeDescription':
        opts = new Set();
        if (formtypes.some(ft => ft.key === 'w8ben_2014')) opts.add({ title: 'W-8BEN Jul-2014', value: 'w8ben_2014' });
        if (formtypes.some(ft => ft.key === 'w8ben')) opts.add({ title: 'W-8BEN Jul-2017', value: 'w8ben' });
        if (formtypes.some(ft => ft.key === 'w8ben_2021')) opts.add({ title: 'W-8BEN Oct-2021', value: 'w8ben_2021' });
        if (formtypes.some(ft => ft.key === 'w8bene')) opts.add({ title: 'W-8BEN-E Apr-2016', value: 'w8bene' });
        if (formtypes.some(ft => ft.key === 'w8bene_2017')) opts.add({ title: 'W-8BEN-E Jul-2017', value: 'w8bene_2017' });
        if (formtypes.some(ft => ft.key === 'w8bene_2021')) opts.add({ title: 'W-8BEN-E Oct-2021', value: 'w8bene_2021' });
        if (formtypes.some(ft => ft.key === 'w8imy')) opts.add({ title: 'W-8IMY Sep-2016', value: 'w8imy' });
        if (formtypes.some(ft => ft.key === 'w8imy_2017')) opts.add({ title: 'W-8IMY Jun-2017', value: 'w8imy_2017' });
        if (formtypes.some(ft => ft.key === 'w8imy_2021')) opts.add({ title: 'W-8IMY Oct-2021', value: 'w8imy_2021' });
        if (formtypes.some(ft => ft.key === 'w8exp_2016')) opts.add({ title: 'W-8EXP Sep-2016', value: 'w8exp_2016' });
        if (formtypes.some(ft => ft.key === 'w8exp')) opts.add({ title: 'W-8EXP Jul-2017', value: 'w8exp' });
        if (formtypes.some(ft => ft.key === 'w8exp_2023')) opts.add({ title: 'W-8EXP Oct-2023', value: 'w8exp_2023' });
        if (formtypes.some(ft => ft.key === 'w8eci_2014')) opts.add({ title: 'W-8ECI Feb-2014', value: 'w8eci_2014' });
        if (formtypes.some(ft => ft.key === 'w8eci')) opts.add({ title: 'W-8ECI Jul-2017', value: 'w8eci' });
        if (formtypes.some(ft => ft.key === 'w8eci_2021')) opts.add({ title: 'W-8ECI Oct-2021', value: 'w8eci_2021' });
        if (formtypes.some(ft => ft.key === 'w9')) opts.add({ title: 'W-9 Dec-2014', value: 'w9' });
        if (formtypes.some(ft => ft.key === 'w9_2017')) opts.add({ title: 'W-9 Nov-2017', value: 'w9_2017' });
        if (formtypes.some(ft => ft.key === 'w9_2018')) opts.add({ title: 'W-9 Oct-2018', value: 'w9_2018' });
        if (formtypes.some(ft => ft.key === 'w9_2024')) opts.add({ title: 'W-9 Oct-2024', value: 'w9_2024' });
        if (formtypes.some(ft => ft.key === 'crscp')) opts.add({ title: 'CRSCP 2017', value: 'crscp' });
        if (formtypes.some(ft => ft.key === 'crse')) opts.add({ title: 'CRSE 2017', value: 'crse' });
        if (formtypes.some(ft => ft.key === 'crsi')) opts.add({ title: 'CRSI 2017', value: 'crsi' });
        if (formtypes.some(ft => ft.key === 'crsi_2024')) opts.add({ title: 'CRSI 2024', value: 'crsi_2024' });
        if (formtypes.some(ft => ft.key === 'dt_crscp')) opts.add({ title: 'Deloitte CRS-CP', value: 'dt_crscp' });
        if (formtypes.some(ft => ft.key === 'dt_crsi')) opts.add({ title: 'Deloitte CRS-I', value: 'dt_crsi' });
        if (formtypes.some(ft => ft.key === 'dt_crse')) opts.add({ title: 'Deloitte CRS-E', value: 'dt_crse' });
        if (formtypes.some(ft => ft.key === 'ucrscp_2025')) opts.add({ title: 'Universal CRSCP 2025', value: 'ucrscp_2025' });
        if (formtypes.some(ft => ft.key === 'ucrse_2025')) opts.add({ title: 'Universal CRSE 2025', value: 'ucrse_2025' });
        if (formtypes.some(ft => ft.key === 'ucrsi_2025')) opts.add({ title: 'Universal CRSI 2025', value: 'ucrsi_2025' });
        if (formtypes.some(ft => ft.key === 'rc518')) opts.add({ title: 'RC518 2023', value: 'rc518' });
        if (formtypes.some(ft => ft.key === 'rc518_2024')) opts.add({ title: 'RC518 2024', value: 'rc518_2024' });
        if (formtypes.some(ft => ft.key === 'rc518_2025')) opts.add({ title: 'RC518 2025', value: 'rc518_2025' });
        if (formtypes.some(ft => ft.key === 'rc519')) opts.add({ title: 'RC519 2023', value: 'rc519' });
        if (formtypes.some(ft => ft.key === 'rc519_2024')) opts.add({ title: 'RC519 2024', value: 'rc519_2024' });
        if (formtypes.some(ft => ft.key === 'rc519_2025')) opts.add({ title: 'RC519 2025', value: 'rc519_2025' });
        if (formtypes.some(ft => ft.key === 'ucarfcp_2026')) opts.add({ title: 'Universal CARF-CP 2026', value: 'ucarfcp_2026' });
        if (formtypes.some(ft => ft.key === 'ucarfi_2026')) opts.add({ title: 'Universal CARF-I 2026', value: 'ucarfi_2026' });
        if (formtypes.some(ft => ft.key === 'ucarfe_2026')) opts.add({ title: 'Universal CARF-E 2026', value: 'ucarfe_2026' });
        break;
      case 'formSourceDescription':
        opts = new Set();
        opts.add({ title: 'Manual Upload', value: 'manualupload' });
        opts.add({ title: 'Online', value: 'online' });
        opts.add({ title: 'Batch', value: 'batch' });
        break;
      case 'isValid':
        opts = new Set();
        opts.add({ value: 'true', title: 'Valid' });
        opts.add({ value: 'false', title: 'Invalid' });
        opts.add({ value: 'null', title: 'N/A' });
        break;
      default:
    }
    return [...opts.values()];
  }, [id]);

  const keyHit = (e) => {
    if (e.keyCode === 13) {
      setShowFilter(false);
      setFilter({
        filter: [inputValue],
        filterType: `${ filterType }`
      });
    }
  };

  React.useEffect(() => {
    setInputValue(null);
  }, [preFilteredRows]);

  React.useEffect(() => {
    setInputValue(filterValue != null && filterValue.filter.length > 0 ? filterValue.filter[0] : '');
  }, [filterValue]);

  React.useEffect(() => {
    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter]);

  if (!options || options.length === 0) {
    options = baseOptions;
  }

  if (!filterType) {
    filterType = `${ filterType }`;
  }

  const clear = () => {
    setShowFilter(false);
    setInputValue(null);
    setFilter({
      filter: [],
      filterType: `${ filterType }`
    });
  };

  return (
    <div id={ filterIconId } ref={ node } className={ `clickover ${ className ?? 'clickover-bottom' } filter ${ showFilter ? 'active' : '' }` }>
      <button type="button" onClick={ () => setShowFilter(!showFilter) } className={ `btn btn-link filter-menu ${ filterValue != null && filterValue.filter[0] != null && filterValue.filter[0] !== 'No Selection' ? 'filter-active' : '' }` }>☰</button>
      <div className="clickover-container">
        <div className="card card-primary">
          <div className="card-body">
            <div className="columns">
              <div className="col-12">
                <select
                  onChange={ (e) => { setInputValue(e.target.value); } }
                  onKeyUp={ (e) => { keyHit(e); } }
                  value={ inputValue ?? 'No Selection' }
                >
                  <option value={ null }>No Selection</option>
                  {options.map((option, i) => (
                    <option key={ (option && option.value) || option } value={ (option && option.value) || option }>
                      { (option && option.title) || option }
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={ () => {
                    setShowFilter(false);
                    setFilter({ filter: [inputValue], filterType: `${ filterType }` });
                  } }
                ><span className="icon icon-search" /> Filter</button>
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={ inputValue === null }
                  onClick={ () => clear() }
                ><span className="icon icon-cross" /> Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SelectFilter.propTypes = {
  column: PropTypes.shape().isRequired,
  filterIconId: PropTypes.string,
  className: PropTypes.string
};

SelectFilter.defaultProps = {
  filterIconId: null,
  className: 'clickover-bottom'
};

export default SelectFilter;
